import { render, staticRenderFns } from "./ButtonBig.vue?vue&type=template&id=07ca9628&scoped=true"
import script from "./ButtonBig.vue?vue&type=script&lang=js"
export * from "./ButtonBig.vue?vue&type=script&lang=js"
import style0 from "./ButtonBig.vue?vue&type=style&index=0&id=07ca9628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ca9628",
  null
  
)

export default component.exports